export const FINALIZED = 'finalized';
export const NEW_DOCUMENT = 'new';
export const REFINALIZED = 'refinalized';
export const FOR_REVISION = 'for-revision';
export const FOR_APPROVAL = 'for-approval';

export const FINAL_DOCUMENT = 611101;
export const DRAFT_DOCUMENT = 611100;
export const TRACKING_DOCUMENT = 611102;
